import api from '../common/api/userLogsApi';

const basePath = '/activity';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  }
};



// WEBPACK FOOTER //
// ./src/services/userLogsService.js